module.exports = __webpack_public_path__ + "static/media/checkmark_check_tick-white_bg.cd99a9c0.svg";